<template>
  <a-button
    size="small"
    class="btn-wrapper-add-link create-link-btn"
    @click="addId"
  >
    <a-icon v-if="icon" :type="icon" />
    {{text}}
  </a-button>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from "vuex";

export default {
  name: 'AddUserButton',
  components: {
    mapState
  },
  props: ['icon', 'text', 'amount' ],
  data () {
    return {}
  },
  methods: {
    async addId (amount) {
      try {
        await this.$store.dispatch('createIds', {
          groupId: this.currentGroup.id,
          amount: this.amount || 1
        })
        await this.$store.dispatch('getAllGroups')
        await this.$store.commit('setCurrentGroup', this.getGroup(this.currentGroup.id))
      // await this.$store.dispatch('getAllMembers')

      } catch(err) {
        this.$message.error("Ошибка "+err.message)
        throw err
      }
    }
  },
  computed: {
    ...mapState({
      currentGroup: state => state.currentGroup,
    }),
    ...mapGetters([
      'getGroup'
    ])
  },
}
</script>
<style scoped lang="scss">

.btn-wrapper-add-link {
  margin-right: 5px;
  margin-top: 5px;
  display: block;
  &--extended-margin {
    margin-right: 10px;
  }
}

</style>